import helper from '../helpers/ApiUrlHelper.js';
export default {
  async getContentSite(slug, siteName) {
    return await fetch(
      `${helper.apiUrl()}/site?slug=${slug}&siteName=${siteName}`
    );
  }
};
